<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <h1>Home - Área Genérica</h1>
          <div class="switch-container">
            <span class="switch-label mr-1">
              Status
            </span>
            <toggle-button class="mb-0 mr-3"
              v-model="form.status"
              :width="80"
              :height="25"
              :labels="{ checked: 'ATIVO', unchecked: 'INATIVO'}"/>
          </div>
        </div>
      </div>
      <div class="card-body">
        <label style="margin-bottom: 5px;">
          Banner* <span class="text-muted text-sm">(Formato JPG/PNG | Recomendação: A imagem deve ter a largura de 740px e a altura de 740px.)</span>
        </label>
        <input type="hidden" name="display" id="display" v-model="form.display" value="1"/>
        <Banner
          :url="mediaUrl + (instance.id ? '/' + imageBannerInstance.id : '')"
          :image="imageBannerInstance"
          :max-file-size="5"
          :height="520"
          :width="740"
          :api-params="mainBannerParams"
          @success="handleUploadMedia">
        </Banner>
        <div class="mt-5" style="margin-bottom:20px">
          <b-tabs v-model="tabIndex">
            <!-- <b-tab title="Mobile" class="pl-0 pr-0">
              <div class="card-body">
                <div class="form-group">
                  <label style="margin-bottom: 5px;">
                  Banner mobile* <span class="text-muted text-sm">(Formato JPG/PNG)</span>
                  </label>
                  <Banner
                    :url="mediaUrl + (instance.id ? '/' + imageMobileInstance.id : '')"
                    :image="imageMobileInstance"
                    :max-file-size="5"
                    :height="370"
                    :width="375"
                    :api-params="mobileBannerParams"
                    @success="handleUploadMedia">
                  </Banner>
                  <input name="banner-mobile" v-model="mobile.lastUploadID" required style="opacity: 0;">
                </div>
              </div>
            </b-tab> -->
            <b-tab title="Informações" class="pl-0 pr-0 informations">
              <div class="card-body">
              <b-row>
                <b-form-group
                  id="group"
                  class="col-lg-6"
                  label="Título*"
                  label-for="title">
                  <b-form-input
                    id="title"
                    type="text"
                    placeholder="Título do banner"
                    v-model="form.heading"
                    maxlength="50"
                    :class="{
                      'is-invalid': form.errors.has('heading')
                    }">
                  </b-form-input>
                  <span class="text-muted caracteres-counter float-right">{{ form.heading.length }}/50 caracteres</span>
                </b-form-group>
                <b-form-group
                  id="group"
                  class="col-lg-6"
                  label="Texto do botão"
                  label-for="button">
                  <b-form-input
                    id="button"
                    type="text"
                    placeholder="Texto do botão"
                    v-model="form.button"
                    :class="{
                      'is-invalid': form.errors.has('button')
                    }">
                  </b-form-input>
                </b-form-group>
                <b-form-group
                  id="group"
                  class="col-lg-4"
                  label="Possui link?*"
                  label-for="has_url">
                  <b-form-select
                    id="has_url"
                    v-model="hasLink"
                    @change="handleUrl">
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  v-if="hasLink"
                  id="group"
                  class="col-lg-4"
                  label="Link*"
                  label-for="link">
                  <b-form-input
                    id="link"
                    type="url"
                    placeholder="http://www.exemplo.com.br"
                    v-model="form.anchor_url"
                    :class="{
                      'is-invalid': form.errors.has('anchor_url')
                    }">
                  </b-form-input>
                </b-form-group>
                <b-form-group
                  v-if="hasLink"
                  id="group"
                  class="col-lg-4"
                  label="Abrir link*"
                  label-for="open_page">
                  <select
                    name="open_page"
                    id="open_page"
                    required
                    v-model="form.anchor_target"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('anchor_target')
                    }">
                    <option :value="target.id" v-for="(target, index) in targets" :key="target[index]"> {{ target.text }} </option>
                  </select>
                </b-form-group>
                <!-- <b-form-group
                  id="group"
                  class="col-lg-4"
                  label="Possui prazo de exibição?*"
                  label-for="expiration">
                  <b-form-select id="expiration" v-model="expiration.enable" @change="handleExpiration">
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </b-form-select>
                </b-form-group>
                <div class="col-lg-4" v-if="expiration.enable">
                  <label>Começa em*</label>
                  <datepicker :form="form" field="begin_at"></datepicker>
                  <small class="form-text text-muted">Será exibido a partir de</small>
                </div>
                <div class="col-lg-4" v-if="expiration.enable">
                  <label>Expira em*</label>
                  <datepicker :form="form" field="end_at"></datepicker>
                  <small class="form-text text-muted">Não será mais exibido a partir de</small>
                </div> -->
                  <b-form-group class="col-12"
                    label="Texto"
                    label-for="text">
                    <b-form-textarea id="text"
                      v-model="text"
                      placeholder="Texto do banner"
                      maxlength="200"
                      :rows="5"
                      :max-rows="10"
                      :class="{
                        'is-invalid': submitted && form.errors.has('text'),
                        'is-valid': submitted && !form.errors.has('text')
                      }">
                    </b-form-textarea>
                    <span class="text-muted caracteres-counter float-right">{{ text.length }}/200 caracteres</span>
                  </b-form-group>
                </b-row>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <div class="card-footer text-right">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import GalleryComponent from '@/components/ui/GalleryComponent.vue'
import Datepicker from '@/components/ui/Datepicker.vue'
import Banner from '@/components/ui/BannerComponent'
import Multiselect from 'vue-multiselect'
import Editor from '../../ui/Editor.vue'
import { isEmpty, set } from 'lodash'
export default {
  components: {
    Banner,
    'gallery': GalleryComponent,
    'multiselect': Multiselect,
    'datepicker': Datepicker,
    Editor
  },

  props: {
    form: {
      type: [Object],
      required: true
    },
    submitted: {
      type: Boolean,
      default: false
    },
    instance: {
      type: Object,
      default () {
        return {
          media: []
        }
      }
    },
    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      media: {},
      banner: {
        image: '',
        lastUploadID: ''
      },
      mobile: {
        image: '',
        lastUploadID: ''
      },
      hasLink: true,
      expiration: {
        enable: false
      },
      mainBannerParams: {
        collection: 'general_banner_main'
      },
      mobileBannerParams: {
        collection: 'general_banner_mobile'
      },
      targets: [
        { id: 1, text: 'Mesma Janela' },
        { id: 2, text: 'Nova Janela' }
      ],
      tabIndex: 0,
      tabBlock: 1,
      text: '',
      empty: {
        heading: '',
        button: '',
        text: '',
        media_ids: [],
        anchor_label: 'text',
        anchor_target: 1,
        anchor_url: '',
        display: 2,
        begin_at: '',
        end_at: '',
        status: true
      }
    }
  },

  watch: {
    text (next) {
      set(this.form, 'text', next)
    }
  },

  computed: {
    mediaUrl () {
      return this.http.routes.uploadMedia(this.instance.id)
    },

    imageBannerInstance () {
      if (!isEmpty(this.banner.image)) {
        return this.banner.image
      }

      if (!isEmpty(this.instance.main)) {
        return this.instance.main[0]
      }

      return {}
    },

    imageMobileInstance () {
      if (!isEmpty(this.mobile.image)) {
        return this.mobile.image
      }

      if (!isEmpty(this.instance.mobile)) {
        return this.instance.mobile[0]
      }

      return {}
    }
  },

  methods: {
    setEditorData (path, value) {
      if (value) {
        set(this.form, path, value)
      } else {
        set(this.form, path, '')
      }
    },
    updateForm (path, value) {
      set(this.form, path, value ? value.id : null)
    },

    handleUploadMedia (file, response, progress) {
      if (response.collection_name === 'general_banner_main') {
        this.banner.image = response
        this.banner.lastUploadID = response.id
      }

      if (response.collection_name === 'general_banner_mobile') {
        this.mobile.image = response
        this.mobile.lastUploadID = response.id
        this.tabIndex = 1
      }

      this.form.media_ids = []

      if (this.banner.lastUploadID) this.form.media_ids.push(this.banner.lastUploadID)
      if (this.mobile.lastUploadID) this.form.media_ids.push(this.mobile.lastUploadID)
    },

    handleExpiration (e) {
      const value = e.value
      if (!value) {
        this.$set(this.form, 'begin_at', '')
        this.$set(this.form, 'end_at', '')
      }
    },

    handleUrl (e) {
      const self = this
      const value = e.value
      if (!value) {
        this.$set(self.form, 'anchor_url', '')
        this.$set(self.form, 'anchor_target', 1)
      }
    },

    objectIsEmpty (obj) {
      return isEmpty(obj)
    }
  },

  created () {
    const self = this

    self.form.withData(self.instance.id ? self.instance : self.empty)
      .setInitialValues(self.instance.id ? self.instance : self.empty)

    if (self.form.begin_at || self.form.end_at) {
      self.expiration.enable = true
    }

    if (self.form.main) {
      if (self.form.main.length > 0) {
        self.banner.lastUploadID = self.form.main[0].id
      }
    }

    if (self.form.mobile) {
      if (self.form.mobile.length > 0) {
        self.mobile.lastUploadID = self.form.mobile[0].id
      }
    }

    if (self.instance.id) {
      this.text = this.instance.text
      if (self.form.anchor_url) {
        self.hasLink = true
      } else {
        self.hasLink = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  label
    padding-bottom: 0;
  .banner-data-preview
    position: absolute
    padding: 1em 2em 1em 2em;
    color: #fff

  .heading-text
    margin-top: 6vh
    font-size: 22px

  .subheading-text
    font-size: 16px

  .anchor-text .btn-outline-secondary
    margin-top: 2vh
    background-color: #fff

  .media-preview.img-fluid
    max-height: 30vh
</style>



// WEBPACK FOOTER //
// src/components/forms/General/OtherBanner.vue